import getObject from './getObject';
export const context = () => getObject().context;
export const pageDetails = () => getObject().pageDetails;
export const state = () => getObject().state;
export const streams = () => getObject().streams;
